import { useEffect, useState } from "react";

const EmailOpenIconFilled = ({ className, fill = "#4D4D4D" }) => {
  const [_class, setClass] = useState(className);

  useEffect(() => {
    let classStr = className || "";
    if (!classStr.includes("w-")) {
      classStr += " w-5";
    }
    if (!classStr.includes("h-")) {
      classStr += " h-5";
    }

    setClass(classStr);
  }, [className]);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 20 20"
      className={_class}
    >
      <path
        d="M1.97656 7.45844L4.16406 5.61677V8.81261L1.97656 7.45844ZM9.73073 0.929274L7.3724 2.91677H12.6224L10.2641 0.929274C10.1892 0.866913 10.0948 0.832764 9.9974 0.832764C9.89996 0.832764 9.8056 0.866913 9.73073 0.929274ZM15.8307 5.61677V8.81261L18.0182 7.45844L15.8307 5.61677ZM10.2182 13.2709C10.152 13.3123 10.0755 13.3343 9.9974 13.3343C9.9193 13.3343 9.84278 13.3123 9.77656 13.2709L1.66406 8.25011V17.9168C1.66406 18.2483 1.79576 18.5662 2.03018 18.8007C2.2646 19.0351 2.58254 19.1668 2.91406 19.1668H17.0807C17.4123 19.1668 17.7302 19.0351 17.9646 18.8007C18.199 18.5662 18.3307 18.2483 18.3307 17.9168V8.25011L10.2182 13.2709ZM15.4141 3.75011V9.07094L9.9974 12.4251L4.58073 9.09177V3.75011C4.58073 3.6396 4.62463 3.53362 4.70277 3.45548C4.78091 3.37734 4.88689 3.33344 4.9974 3.33344H14.9974C15.1079 3.33344 15.2139 3.37734 15.292 3.45548C15.3702 3.53362 15.4141 3.6396 15.4141 3.75011ZM6.36823 6.12927L7.20156 6.96261C7.2405 7.00122 7.28667 7.03178 7.33743 7.05251C7.3882 7.07325 7.44256 7.08376 7.4974 7.08344H7.52656C7.58626 7.07914 7.64432 7.06202 7.69681 7.03326C7.7493 7.0045 7.79497 6.96477 7.83073 6.91677L9.08073 5.25011L8.41406 4.75011L7.45156 6.03344L6.9599 5.53761L6.36823 6.12927ZM11.6641 9.58344H8.7474V10.4168H11.6641V9.58344ZM13.7474 7.91677H6.2474V8.75011H13.7474V7.91677ZM13.7474 6.25011H9.9974V7.08344H13.7474V6.25011ZM13.7474 4.58344H9.9974V5.41677H13.7474V4.58344Z"
        fill={fill}
      />
    </svg>
  );
};

export default EmailOpenIconFilled;
